import React from 'react';
import { bool, shape, string, func } from 'prop-types';
import styled from 'styled-components';
import { reduxForm } from 'redux-form';

import { Button } from 'semantic-ui-react';
import AuthorItem from './AuthorItem';

const Container = styled.div`
    display: flex;
    align-items: center;
`;

const StyledAuthorItem = styled(AuthorItem)`
    flex: 1;
    margin-left: 1rem;
`;

const AuthorSelector = ({
    readOnly,
    selected,
    toggleEditMode,
}) => {

    const name = selected.get('name');
    const logo_url = selected.get('logo_url');

    const nameToShow = name || 'Unable to fetch the author name'; // Default text if name is undefined
    return (
        <Container>
            <StyledAuthorItem name={nameToShow} logo_url={logo_url} />
            <Button
                type="button"
                primary={!readOnly}
                disabled={readOnly}
                content={readOnly ? 'read only' : 'Edit'}
                onClick={toggleEditMode}
            />
        </Container>
    );
};

AuthorSelector.propTypes = {
    readOnly: bool.isRequired,
    selected: shape({
        name: string.isRequired,
        logo_url: string.isRequired,
    }).isRequired,
    toggleEditMode: func.isRequired,
    handleSubmit: func.isRequired, // added to convert to redux form
};

const AuthorSelectorForm = reduxForm({
    form: 'authorSelectorForm',
    validate: undefined,
    asyncValidate: undefined,
})(AuthorSelector);

export default AuthorSelectorForm;
